"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocumentReviewDispatch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const react_redux_1 = require("react-redux");
const sliceReview_1 = __importDefault(require("./slice/sliceReview"));
const sliceTemplate_1 = __importDefault(require("./slice/sliceTemplate"));
const store = (0, toolkit_1.configureStore)({
    reducer: {
        review: sliceReview_1.default,
        template: sliceTemplate_1.default,
    },
    middleware: (getDefaultMiddleware) => 
    // assets uploaded are non-serializable data
    // this middleware is used to turn off redux-toolkit warnings
    getDefaultMiddleware({
        serializableCheck: false,
    }),
});
// eslint-disable-next-line
const useDocumentReviewDispatch = () => (0, react_redux_1.useDispatch)();
exports.useDocumentReviewDispatch = useDocumentReviewDispatch;
exports.default = store;
